import React from 'react';
import { createClassName } from '@/helpers';
import PrimitiveRenderer from '../../shared/PrimitiveRenderer';
import { systemStrokeWidthProps, wizardStrokeWidthProps } from './styles';

const PageShapeRenderer = props => {
  const {
    shapeObj: { primitiveType, primitiveProps, id, logicalType },
    useFineStrocke,
  } = props;
  const localSystemStrokeWidthProps = useFineStrocke ? wizardStrokeWidthProps : systemStrokeWidthProps;
  const style = primitiveProps.style || { cursor: 'default', fill: null, ...localSystemStrokeWidthProps };
  const clickable = false;
  const className = createClassName({ clickable });

  return (
    <PrimitiveRenderer
      style={style}
      className={className}
      id={id}
      primitiveType={primitiveType}
      primitiveProps={primitiveProps}
      clickable={clickable}
      onFastClickTap={null}
      withMiddleLines={false}
      shapeObj={null}
      logicalType={logicalType}
    />
  );
};

export default React.memo(PageShapeRenderer);
